import { inject } from '@angular/core';
import { SavedList, SavedListApi } from '@idealsupply/ngclient-webservice-shopping-cart';
import { signalStore } from '@ngrx/signals';
import { withCachedEntityStore } from 'state-data';

export const SavedPartListDetailStore = signalStore(
  { providedIn: 'root' },
  withCachedEntityStore({
    selectId: (p: SavedList) => `${p.listType ?? 1}|${p.id}`,
    load: (id: string) => {
      const parts = id.split('|');
      const listId = parts[1];
      const listType = +parts[0] as 1 | 2;
      return inject(SavedListApi).getSavedList(listId, listType);
    },
  }),
);
